import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgOrderdetailsMid } from './svg/orderdetails-mid.svg.js';

/**
 * @deprecated - use OrderDetail.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const OrderdetailsMid = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgOrderdetailsMid, { viewBox: "-1.33 -1.33 26.66 26.66", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "OrderdetailsMid" }));
};

export { OrderdetailsMid as default };
//# sourceMappingURL=OrderdetailsMid.js.map
